import { Text } from '@bechtel/gds';
import { find } from 'lodash';
import { FC } from 'react';
import { useLanguage } from '~/components/molecules';
import { MetadataTextProps } from './types';

export const MetadataText: FC<MetadataTextProps> = ({ metadataTable, memberName, ...rest }) => {
  const { isAlternateLanguageUsed } = useLanguage();
  const metadataColumn =
    find(metadataTable?.metadataColumns, (item) => item.memberName === memberName) ??
    find(metadataTable?.relatedDisplayColumns, (item) => item.memberName === memberName);

  const columPrompt = !isAlternateLanguageUsed ? metadataColumn?.columnPrompt : metadataColumn?.alternateColumnPrompt;

  return (
    <Text size="300" weight="400" color="grey.800" {...rest}>
      {columPrompt}
    </Text>
  );
};
